import React, { useState, useEffect, useRef, useReducer } from 'react'
import {
  Panel,
  Message,
  Row,
  Col,
  ControlLabel,
  Input,
  RadioGroup,
  Radio,
  SelectPicker,
  Uploader,
  Icon,
  Checkbox,
  Button,
  Modal,
  Table,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
  isSupportFileByNameType,
} from '../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'
import { DATE_FORMAT, DATE_PICKER_FORMAT } from '../../constants/date'
import moment from 'moment'
import { budgetFormat } from '../../utils/formatterUtil'
import { getTaxWaiteSend, getExpensesAttachments } from '../../redux/actions/accountingExpenses'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import { startLoading, doneLoading } from '../../utils/loading'
import IncomeRecordFileTable from '../../widgets/incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { sessionGetItemJSON } from '../../utils/sessionHelpers'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'

export default function ExpenseRecordForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  onSelectWaitSendTax = () => {},
  formTableDatas,
  projectStartDate,
  projectEndDate,
  isSendTax,
  ...props
}) {
  const triggerRef = React.useRef()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [valueAccChannel, setValueAccChannel] = useState(
    _schema.accountChannel.value ? _schema.accountChannel.value : '2'
  )

  const [valuePayType, setValuePayType] = useState(_schema.payTypeOptions.value || '1')

  const [fileTypeError, setFileTypeError] = useState(false)
  const [showPendingTaxList, setShowPendingTaxList] = useState(false)

  const [fileList, setFileList] = useState([])

  const [supportFileError, setSupportFileError] = useState(false)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)

  const [waitSendTaxSchema, setWaitSendTaxSchema] = useState()

  const [waitSendTaxType, setWaitSendTaxType] = useState()
  const [waitSendTaxMount, setWaitSendTaxMount] = useState()
  const [errorSearchTaxWaiteSend, setErrorSearchTaxWaiteSend] = useState()

  const [fileTableData, setFileTableData] = useState([])

  const [checkedAll, setCheckedAll] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)
  const [checkedKeys, setCheckedKeys] = useState([])
  const [waitSendTaxSelected, setWaitSendTaxSelected] = useState([])

  const [tempCheckedAll, setTempCheckedAll] = useState(false)
  const [tempIndeterminate, setTempIndeterminate] = useState(false)
  const [tempSendTaxSelected, setTempSendTaxSelected] = useState([])
  const [tempCheckedKeys, setTempCheckedKeys] = useState([])

  const [disabledSendTax, setDisabledSendTax] = useState(false)

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'
  const defaultMaxFileSize = 5

  useEffect(() => {
    let periodDateEnd = moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
    let today = moment().startOf('day').toDate()

    setValue(formSchema?.payTypeOptions?.name, formSchema?.payTypeOptions?.value || '1')
    setValue(
      formSchema?.accountChannel?.name,
      formSchema.accountChannel.value ? formSchema.accountChannel.value : '2'
    )
    //setValue(formSchema?.attachFiles?.name, formSchema?.attachFiles?.values)

    if (formSchema.accountChannel.value == '3') {
      setValue(formSchema?.checkBankInput?.name, formSchema?.checkBankInput?.value)
    } else {
      setValue(formSchema?.bankInput?.name, formSchema?.bankInput?.value)
    }

    setValue(formSchema?.description?.name, formSchema?.description?.value)
    setValue(
      formSchema?.checkDocDate?.name,
      formSchema?.checkDocDate?.value
        ? moment(
            moment(formSchema.checkDocDate.value).format(DATE_PICKER_FORMAT),
            DATE_PICKER_FORMAT
          ).toDate()
        : today > periodDateEnd
          ? periodDateEnd
          : today
    )
    setValue(formSchema?.checkDocNumber?.name, formSchema?.checkDocNumber?.value)
    setValue(formSchema?.referenceNumber?.name, formSchema?.referenceNumber?.value)

    setValue(formSchema?.referenceNumber?.name, formSchema?.referenceNumber?.value)

    setValue(
      formSchema?.voucherDate?.name,
      formSchema?.voucherDate?.value
        ? moment(
            moment(formSchema.voucherDate.value).format(DATE_PICKER_FORMAT),
            DATE_PICKER_FORMAT
          ).toDate()
        : today > periodDateEnd
          ? periodDateEnd
          : today
    )
    setValue(formSchema?.voucherNumber?.name, formSchema?.voucherNumber?.value || 'P-YY-XXXXX')

    register('deleteFileIds', [])
    if (formSchema?.attachFiles?.values && formSchema?.attachFiles?.values?.length > 0) {
      setFileTableData(formSchema?.attachFiles?.values)
    }
  }, [formSchema])

  useEffect(() => {
    if (formTableDatas && formTableDatas.length > 0) {
      let index = formTableDatas.findIndex((item) => item.id.indexOf('addNew') > -1)
      if (index > -1) {
        if (formTableDatas[index]?.id?.indexOf('sendTax') > -1) {
          setDisabledSendTax(false)
        } else {
          setDisabledSendTax(true)
        }
      } else {
        setDisabledSendTax(false)
      }
    }
  }, [formTableDatas])

  const handleShowPendingTaxList = async () => {
    await handleSearchTaxWaiteSend()

    tempCheckedKeys.length > 0 && handleDisableWaitSendTax(tempCheckedKeys)
    setShowPendingTaxList(true)
  }

  const handleSearchTaxWaiteSend = async (type, mount) => {
    try {
      var result = await getTaxWaiteSend(
        projectCode,
        formSchema.period || periodInfo?.periodNumber,
        type,
        mount
      )

      if (result?.model) {
        setWaitSendTaxSchema(result?.model)
        // setWaitSendTaxSchema(xxx.model)
      }
    } catch (error) {
      console.log(error)
      setErrorSearchTaxWaiteSend(DEFAULT_ERR_MSG)
    }
  }

  const onAddFile = (file) => {
    setFileList(file)
    setValue(formSchema.attachFiles.name, file)
  }

  const onUploaderChange = (files) => {
    let file = files[files.length - 1]
    let isSupportSize = true
    let isSupportType = isSupportFileByNameType(
      file?.blobFile.name,
      formSchema.attachFiles.fileType || defaultSupportType
    )

    if (formSchema.attachFiles.fileSize && formSchema.attachFiles.fileSize > 0) {
      isSupportSize = file?.blobFile.size <= formSchema.attachFiles.fileSize * 1024 * 1024
      setIsOverSize(!isSupportSize)
    }

    setIsNotSupportType(!isSupportType)

    // console.log('isSupportType', isSupportType, 'isSupportSize', isSupportSize)

    if (!file || (isSupportType && isSupportSize)) {
      onAddFile(files)
      setSupportFileError(false)
    } else {
      files.splice(files.length - 1, 1)
      onAddFile(fileList)
      setSupportFileError(true)
    }
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getExpensesAttachments(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getExpensesAttachments(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDeleteFileTable = (rowData) => {
    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  const handleDisableWaitSendTax = (keys) => {
    let waitSendTax = waitSendTaxSchema?.values
    let taxType, month_year
    let newWaitSendTax = []

    if (keys.length > 0) {
      waitSendTax.forEach((item) => {
        if (item.id == keys[0]) {
          taxType = item.taxType
          month_year = item?.transactionDate?.substring(3) || undefined
        }
      })
    }

    if (taxType && month_year) {
      newWaitSendTax = waitSendTax.map((item) => {
        let my = item?.transactionDate?.substring(3) || undefined

        if (item.taxType != taxType) {
          return {
            ...item,
            disabled: true,
          }
        }

        if (month_year != my) {
          return {
            ...item,
            disabled: true,
          }
        }

        return {
          ...item,
          disabled: false,
        }
      })
    } else {
      newWaitSendTax = waitSendTax.map((item) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }

    setWaitSendTaxSchema((schema) => ({
      ...schema,
      values: newWaitSendTax,
    }))
  }

  const handleCheckAll = (value, checked) => {
    //console.log('value : ', value, ', checked: ', checked)
    //let keys = checked ? waitSendTaxSchema?.values?.map((item) => item.id) : []
    //keys.pop()

    let keys = []
    let rowSelected = []
    if (checked) {
      if (checkedKeys.length > 0) {
        waitSendTaxSchema?.values?.forEach((item) => {
          if (item.id && !item.disabled) {
            keys.push(item.id)
            rowSelected.push(item)
          }
        })
      } else {
        if (waitSendTaxSchema?.values?.length > 0) {
          let firstTaxtype = waitSendTaxSchema?.values[0].taxType || ''
          let firstMonthYear = waitSendTaxSchema?.values[0]?.transactionDate?.substring(3) || ''

          waitSendTaxSchema?.values?.forEach((item) => {
            let my = item?.transactionDate?.substring(3) || undefined

            if (item.taxType == firstTaxtype && firstMonthYear == my) {
              keys.push(item.id)
              rowSelected.push(item)
            }
          })
        }
      }
    }

    setCheckedAll(checked)
    setIndeterminate(false)
    setCheckedKeys(keys)
    setWaitSendTaxSelected(rowSelected)

    handleDisableWaitSendTax(keys)
  }

  const handleCheck = (value, checked, rowData) => {
    const keys = checked ? [...checkedKeys, value] : checkedKeys.filter((item) => item !== value)

    if (keys.length === 0) {
      setCheckedAll(false)
    } else if (keys.length > 0 && keys.length < waitSendTaxSchema?.values?.length) {
      setIndeterminate(true)
    }

    const rowSelected = checked
      ? [...waitSendTaxSelected, rowData]
      : waitSendTaxSelected.filter((item) => item.id !== value)

    setCheckedKeys(keys)
    setWaitSendTaxSelected(rowSelected)

    handleDisableWaitSendTax(keys)
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={
          periodInfo && (
            <div style={{ textAlign: 'left' }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                {formSchema.header || (
                  <span>{periodInfo?.periodNo + ' (' + periodInfo?.startAndEndDate + ')'}</span>
                )}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <span>
                  {'งวดที่ ' + periodInfo?.periodNumber + '/' + periodInfo?.periodOfLength}
                </span>
              </Col>
            </div>
          )
        }
      >
        <Row style={{ marginTop: 10 }}>
          <Col lg={16} md={16} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherNumber.validators, formSchema.voucherNumber.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.voucherNumber.value ? (
              <b>{formSchema.voucherNumber.value}</b>
            ) : (
              <>
                <ErrorMessage error={errors[formSchema.voucherNumber.name]} />
                <Controller
                  name={formSchema.voucherNumber.name}
                  control={control}
                  defaultValue={formSchema.voucherNumber.value}
                  rules={isValidators(formSchema.voucherNumber.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={'ระบุ' + formSchema.voucherNumber.label}
                        value={props.value}
                        maxLength={getMaxLengthData(formSchema.voucherNumber.validators).value}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.voucherNumber.disabled}
                      />
                    )
                  }}
                />
              </>
            )}
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.payTypeOptions.validators, formSchema.payTypeOptions.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.payTypeOptions.name]} />
            <Controller
              name={formSchema.payTypeOptions.name}
              control={control}
              defaultValue={formSchema.payTypeOptions.value || '1'}
              rule={register(isValidators(formSchema.payTypeOptions.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      setValuePayType(value)
                      if (value == '2') {
                        setValueAccChannel('1')
                        setValue(formSchema.accountChannel.name, '1')
                      } else {
                        setValueAccChannel('2')
                        setValue(formSchema.accountChannel.name, '2')
                      }
                      // else {
                      //   valueAccChannel == '2'
                      //     ? setValueAccChannel('1')
                      //     : setValueAccChannel(valueAccChannel)
                      // }
                      // if (value == '1') {
                      //   setValueAccChannel('2')
                      //   setValue(formSchema.accountChannel.name, '2')
                      // } else if (value == '2') {
                      //   setValueAccChannel('1')
                      //   setValue(formSchema.accountChannel.name, '1')

                      // }
                    }}
                  >
                    {formSchema.payTypeOptions.options.map((item) => (
                      <Radio key={item.value} value={item.value}>
                        {item.label}
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>

          <Col
            lg={4}
            md={4}
            sm={24}
            xs={24}
            style={{ textAlign: 'right', marginTop: 10, marginBottom: 20 }}
          >
            <ControlLabel>
              {requiredFiled(
                formSchema.referenceNumber.validators,
                formSchema.referenceNumber.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: 10, marginBottom: 20 }}>
            <ErrorMessage error={errors[formSchema.referenceNumber.name]} />
            <Controller
              name={formSchema.referenceNumber.name}
              control={control}
              defaultValue={formSchema.referenceNumber.value || ''}
              rules={isValidators(formSchema.referenceNumber.validators)}
              render={(props) => {
                return (
                  <Input
                    placeholder={'ระบุ' + formSchema.referenceNumber.label}
                    value={props.value}
                    maxLength={getMaxLengthData(formSchema.referenceNumber.validators).value}
                    onChange={(value, e) => {
                      props.onChange(value)
                    }}
                    disabled={formSchema.referenceNumber.disabled}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.accountChannel.validators, formSchema.accountChannel.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.accountChannel.name]} />
            <Controller
              name={formSchema.accountChannel.name}
              control={control}
              defaultValue={valueAccChannel}
              //value={valueAccChannel}
              rule={register(isValidators(formSchema.accountChannel.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    inline
                    value={valueAccChannel}
                    onChange={(value) => {
                      props.onChange(value)
                      setValueAccChannel(value)
                    }}
                  >
                    {formSchema.accountChannel.options.map((item) => (
                      <Radio
                        key={item.value}
                        value={item.value}
                        disabled={
                          (valuePayType == 1 && item.value == 1) ||
                          (valuePayType == 2 && item.value != 1)
                        }
                      >
                        {item.label}
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />

            {/* {valueAccChannel == 1 && formSchema?.monnyTest && (
              <>
                <ErrorMessage error={errors[formSchema.monnyTest.name]} />
                <Controller
                  name={formSchema.monnyTest.name}
                  control={control}
                  defaultValue={formSchema.monnyTest.value || ''}
                  rules={isValidators(formSchema.monnyTest.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={'ระบุ' + formSchema.monnyTest.label}
                        value={props.value}
                        type="number"
                        maxLength={getMaxLengthData(formSchema.monnyTest.validators).value}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.monnyTest.disabled}
                      />
                    )
                  }}
                />
              </>
            )} */}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherDate.validators, formSchema.voucherDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.voucherDate.name]} />
            <Controller
              key={formSchema.voucherDate.name}
              name={formSchema.voucherDate.name}
              control={control}
              defaultValue={
                formSchema.voucherDate.value
                  ? moment(
                      moment(formSchema.voucherDate.value).format(DATE_PICKER_FORMAT),
                      DATE_PICKER_FORMAT
                    ).toDate()
                  : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                    ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                    : new Date()
              }
              rules={isValidators(formSchema.voucherDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    startDate={periodInfo?.periodDateStart}
                    // endDate={periodInfo?.periodDateEnd}
                    endDate={moment.min(moment(), moment(periodInfo?.periodDateEnd))}
                    // startDate={sessionGetItemStr('projectStartDate')}
                    // endDate={sessionGetItemStr('projectEndDate')}
                  />
                )
              }}
            />
          </Col>
        </Row>

        {valueAccChannel == 2 && formSchema?.bankInput && (
          <Row>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>
                {requiredFiled(formSchema.bankInput.validators, formSchema.bankInput.label)}
              </ControlLabel>
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <ErrorMessage error={errors[formSchema.bankInput.name]} />
              <Controller
                name={formSchema.bankInput.name}
                control={control}
                defaultValue={formSchema.bankInput.value}
                rules={isValidators(formSchema.bankInput.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      style={{ minWidth: '40%' }}
                      virtualized={false}
                      searchable={true}
                      data={formSchema.bankInput.options}
                      value={props.value}
                      menuAutoWidth
                      placeholder={'เลือก' + formSchema.bankInput.label}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </Row>
        )}
        {valueAccChannel == 3 && (
          <>
            <Row style={{ marginTop: 10, marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkDocNumber.validators,
                    `${formSchema.checkDocNumber.label}`
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkDocNumber.name]} />
                <Controller
                  name={formSchema.checkDocNumber.name}
                  control={control}
                  defaultValue={formSchema.checkDocNumber.value || ''}
                  rules={isValidators(formSchema.checkDocNumber.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={'ระบุ' + formSchema.checkDocNumber.label}
                        value={props.value}
                        type="number"
                        maxLength={getMaxLengthData(formSchema.checkDocNumber.validators).value}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.checkDocNumber.disabled}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10, marginBottom: 10, textAlign: 'right' }}>
              <Col lg={4} md={4} sm={24} xs={24}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkDocDate.validators,
                    `${formSchema.checkDocDate.label}`
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkDocDate.name]} />
                <Controller
                  key={formSchema.checkDocDate.name}
                  name={formSchema.checkDocDate.name}
                  control={control}
                  defaultValue={
                    formSchema.checkDocDate.value
                      ? moment(
                          moment(formSchema.checkDocDate.value).format(DATE_PICKER_FORMAT),
                          DATE_PICKER_FORMAT
                        ).toDate()
                      : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                        ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                        : new Date()
                  }
                  rules={isValidators(formSchema.checkDocDate.validators)}
                  render={(props) => {
                    return (
                      <DatePickerCustom
                        {...props}
                        startDate={periodInfo?.periodDateStart}
                        endDate={periodInfo?.periodDateEnd}
                      />
                      // <DatePicker
                      //   format={DATE_PICKER_FORMAT}
                      //   locale={LOCAL_DAY_TH}
                      //   block
                      //   oneTap
                      //   value={props.value}
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //     // onChangeReportDate(value)
                      //   }}
                      // />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkBankInput.validators,
                    formSchema.checkBankInput.label
                  )}
                </ControlLabel>
              </Col>
              <Col lg={20} md={20} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkBankInput.name]} />
                <Controller
                  name={formSchema.checkBankInput.name}
                  control={control}
                  defaultValue={formSchema.checkBankInput.value}
                  rules={isValidators(formSchema.checkBankInput.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        style={{ minWidth: '40%' }}
                        virtualized={false}
                        searchable={true}
                        data={formSchema.checkBankInput.options}
                        value={props.value}
                        menuAutoWidth
                        placeholder={'เลือก' + formSchema.checkBankInput.label}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.description.validators, formSchema.description.label)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.description.name]} />
            <Controller
              name={formSchema.description.name}
              control={control}
              defaultValue={formSchema.description.value || ''}
              rules={isValidators(formSchema.description.validators)}
              render={(props) => {
                return (
                  <>
                    <Input
                      componentClass="textarea"
                      rows={4}
                      placeholder={'ระบุ' + formSchema.description.label}
                      value={props.value}
                      maxLength={getMaxLengthData(formSchema.description.validators).value}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      disabled={formSchema.description.disabled}
                    />
                    <ShowLimitLength
                      textLength={props.value?.length || 0}
                      maxLength={getMaxLengthData(formSchema.description.validators)?.value}
                    />
                  </>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {disabledSendTax || (typeof isSendTax == 'undefined' ? false : !isSendTax)
                ? requiredFiled(
                    formSchema.attachFiles.validators,
                    formSchema.attachFiles.labe || 'เอกสารแนบประกอบ'
                  )
                : requiredFiled(null, formSchema.attachFiles.labe || 'เอกสารแนบประกอบ')}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {/* <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${
                formSchema.attachFiles.fileType || defaultSupportType
              } ${
                formSchema.attachFiles.fileSize && formSchema.attachFiles.fileSize > 0
                  ? `, ขนาดไฟล์ไม่เกิน ${formSchema.attachFiles.fileSize} MB`
                  : ''
              }`}
              style={{ marginBottom: 10 }}
            /> */}

            <ErrorMessage error={errors[formSchema.attachFiles.name]} />

            {supportFileError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                closable
                onClose={() => {
                  setSupportFileError(false)
                }}
                showIcon
                type="error"
                description={`${
                  isNotSupportType
                    ? `อัพโหลดไฟล์ได้เฉพาะที่รองรับเท่านั้น *** ชนิดที่รองรับ ${
                        formSchema.attachFiles.fileType || defaultSupportType
                      } ***`
                    : ''
                }  ${isOverSize ? ` ขนาดไฟล์เกิน ${formSchema.attachFiles.fileSize} MB ` : ''}`}
              />
            )}

            <Controller
              key={formSchema.attachFiles.name}
              name={formSchema.attachFiles.name}
              control={control}
              rules={
                (disabledSendTax || (typeof isSendTax == 'undefined' ? false : !isSendTax)) &&
                isValidators(fileTableData.length == 0 && formSchema.attachFiles.validators)
              }
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.attachFiles.fileType || defaultSupportType}
                    autoUpload={false}
                    fileListVisible={true}
                    fileList={props.value || []}
                    listType="picture-text"
                    multiple
                    onChange={(fileList) => {
                      //onUploaderChange(files)
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setFileTypeError(false)
                        } else {
                          setFileTypeError(true)
                          notification.open('error', {
                            title:
                              'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                              '.jpg, .jpeg, .png, .pdf',
                            duration: 5000,
                          })
                        }
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text"></small>
                      {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                        formSchema.attachFiles.fileType || defaultSupportType
                      } , ขนาดไฟล์ไม่เกิน ${
                        formSchema.attachFiles.fileSize || defaultMaxFileSize
                      } MB`}
                    </div>
                    {/* <div style={{ lineHeight: '100px' }}>
                      <Icon size="4x" icon="upload2" />
                      <small
                        style={{
                          marginTop: '-70px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่อใช้อัปโหลด
                      </small>
                    </div> */}
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={true}
                onPreview={onPreview}
                onDownload={onDownload}
                onDelete={(rowData) => handleDeleteFileTable(rowData)}
              />
            )}
          </Col>
        </Row>

        <Row style={{ marginTop: 25 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right', marginTop: 10 }}>
            <Button
              appearance="primary"
              onClick={handleShowPendingTaxList}
              disabled={disabledSendTax || (typeof isSendTax == 'undefined' ? false : !isSendTax)}
            >
              รายการภาษีรอนำส่ง
            </Button>
          </Col>
        </Row>

        {/* รายการภาษีรอนำส่ง */}
        <Modal
          show={showPendingTaxList}
          // size="lg"
          full
          onHide={() => {
            setShowPendingTaxList(false)
            setCheckedAll(tempCheckedAll)
            setIndeterminate(tempIndeterminate)
            setCheckedKeys(tempCheckedKeys)
            setWaitSendTaxSelected(tempSendTaxSelected)
          }}
        >
          <Modal.Header>
            <Modal.Title>รายการภาษีรอนำส่ง</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ padding: 15 }}>
              {waitSendTaxSchema && (
                <div style={{ width: '98%' }}>
                  <Row style={{ marginBottom: 10 }}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      {waitSendTaxSchema.texType.label}
                      <SelectPicker
                        searchable={true}
                        data={waitSendTaxSchema.texType.options}
                        value={props.value}
                        block
                        placeholder={'เลือก' + waitSendTaxSchema.texType.label}
                        onChange={(value) => {
                          setWaitSendTaxType(value)
                          handleSearchTaxWaiteSend(value, waitSendTaxMount)

                          //เพิ่มมาเพื่อ clear ค่า
                          setCheckedAll(false)
                          setIndeterminate(false)
                          setCheckedKeys([])
                          setWaitSendTaxSelected([])
                        }}
                      />
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      {waitSendTaxSchema.month.label}
                      <SelectPicker
                        searchable={true}
                        data={waitSendTaxSchema.month.options}
                        value={props.value}
                        block
                        placeholder={'เลือก' + waitSendTaxSchema.month.label}
                        onChange={(value) => {
                          setWaitSendTaxMount(value)
                          handleSearchTaxWaiteSend(waitSendTaxType, value)

                          //เพิ่มมาเพื่อ clear ค่า
                          setCheckedAll(false)
                          setIndeterminate(false)
                          setCheckedKeys([])
                          setWaitSendTaxSelected([])
                        }}
                      />
                    </Col>
                  </Row>

                  {/* <Table minHeight={800} autoHeight data={waitSendTaxSchema?.values || []}> */}
                  <Table
                    height={
                      waitSendTaxSchema?.values ? waitSendTaxSchema?.values?.length * 46 + 56 : 400
                    }
                    data={waitSendTaxSchema?.values || []}
                    style={{ marginBottom: -10 }}
                  >
                    {/* <Column width={70} align="center" fixed>
                    <HeaderCell>
                      <Checkbox style={{ marginTop: -6 }} />
                    </HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        if (rowData.isTotal) {
                          return ''
                        }

                        return <Checkbox style={{ marginTop: -6 }} />
                      }}
                    </Cell>
                  </Column> */}
                    <Column width={30} align="center" fixed>
                      <HeaderCell style={{ padding: 0 }}>
                        {/* <div style={{ lineHeight: '40px' }}> */}
                        <div style={{ padding: 10 }}>
                          <Checkbox
                            style={{ marginTop: '-7px', marginLeft: -10 }}
                            disabled={
                              waitSendTaxSchema?.values?.filter((item) => !item.isTotal).length > 0
                                ? false
                                : true
                            }
                            inline
                            checked={checkedAll}
                            indeterminate={indeterminate}
                            onChange={handleCheckAll}
                          />
                        </div>
                        {/* </div> */}
                      </HeaderCell>
                      <Cell style={{ padding: 0 }}>
                        {(rowData, index) => {
                          if (rowData.isTotal) {
                            return ''
                          }
                          return (
                            // <div style={{ lineHeight: '46px' }}>
                            <div style={{ padding: 10 }}>
                              <Checkbox
                                style={{ marginTop: '-7px', marginLeft: -10 }}
                                value={rowData.id}
                                disabled={rowData.disabled}
                                inline
                                onChange={(value, checked) => handleCheck(value, checked, rowData)}
                                checked={checkedKeys.some((item) => item === rowData.id)}
                              />
                            </div>
                            // </div>
                          )
                        }}
                      </Cell>
                      {/* <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} /> */}
                    </Column>

                    <Column width={70} align="center" fixed>
                      <HeaderCell>ลำดับ</HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          if (rowData.isTotal) {
                            return ''
                          }
                          return index + 1
                        }}
                      </Cell>
                    </Column>

                    <Column width={200}>
                      <HeaderCell>ชื่อผู้ถูกหักภาษี</HeaderCell>
                      <Cell dataKey="name" />
                      {/* <Cell>
                      {(rowData) => {
                        if (rowData.isTotal) {
                          return <b>{rowData.name}</b>
                        }
                        return rowData.name
                      }}
                    </Cell> */}
                    </Column>
                    <Column width={250} minWidth={250} flexGrow={1}>
                      <HeaderCell>รายการ</HeaderCell>
                      {/* <Cell dataKey="name" /> */}
                      <Cell>
                        {(rowData) => {
                          if (rowData.isTotal) {
                            return (
                              <div style={{ width: '100%', textAlign: 'right' }}>
                                <b>{rowData.detail}</b>{' '}
                              </div>
                            )
                          }
                          return rowData.detail
                        }}
                      </Cell>
                    </Column>

                    <Column width={140} align="right">
                      <HeaderCell>จำนวน</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          if (rowData.isTotal) {
                            return <b>{budgetFormat(rowData.tax)}</b>
                          }
                          return budgetFormat(rowData.tax)
                        }}
                      </Cell>
                    </Column>

                    <Column width={130} align="center">
                      <HeaderCell>ประเภทภาษี</HeaderCell>
                      <Cell dataKey="taxType" />
                    </Column>

                    <Column width={150} align="center">
                      <HeaderCell>วันที่ทำรายการ</HeaderCell>
                      <Cell dataKey="transactionDate" />
                    </Column>
                  </Table>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                setShowPendingTaxList(false)
                onSelectWaitSendTax(waitSendTaxSelected)
                setTempCheckedAll(checkedAll)
                setTempIndeterminate(indeterminate)
                setTempSendTaxSelected(waitSendTaxSelected)
                setTempCheckedKeys(checkedKeys)
              }}
              appearance="primary"
              disabled={
                waitSendTaxSelected?.filter((item) => !item.isTotal).length > 0 ? false : true
              }
            >
              เพิ่มรายการ
            </Button>
            <Button
              onClick={() => {
                setShowPendingTaxList(false)
                setCheckedAll(tempCheckedAll)
                setIndeterminate(tempIndeterminate)
                setCheckedKeys(tempCheckedKeys)
                setWaitSendTaxSelected(tempSendTaxSelected)
              }}
              appearance="subtle"
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>
        {/* </div> */}
      </Panel>
    </>
  )
}
